import { strCol, numCol } from '@integec/grid-tools/lib/cols'
// eslint-disable-next-line no-unused-vars
import { WEE_CLIENT, AEPREG, AEPUNREG } from 'client'
// eslint-disable-next-line no-unused-vars
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'

export const getHeader = clientCode => {
  if (clientCode === WEE_CLIENT) return WEEheaders
  return AepHeaders
}

export const getReadOnlyCols = clientCode => {
  if (clientCode === WEE_CLIENT) return WEeReadOnlyCols
  return AepReadOnlyCols
}

export const getBlackColsSet = clientCode => {
  if (clientCode === WEE_CLIENT) return WEeBlackColsSet
  return AepBlackColsSet
}

export const getMapEditRow = clientcode => {
  if (clientcode === WEE_CLIENT) return WEeMapEditRow
  return AepMapEditRow
}

const AepMapEditRow = data => ({
  ...data,
  contractOverThrs: data.contractOverThrs === '' ? null : data.contractOverThrs,
  forcedOverThrs: data.forcedOverThrs === '' ? null : data.forcedOverThrs,
  maintOverThrs: data.maintOverThrs === '' ? null : data.maintOverThrs,
  plannedThrs: data.plannedThrs === '' ? null : data.plannedThrs,
  ruOverThrs: data.ruOverThrs === '' ? null : data.ruOverThrs,
  omcForcedThrs: data.omcForcedThrs === '' ? null : data.omcForcedThrs,
  grossKWHOver: data.grossKWHOver === '' ? null : data.grossKWHOver,
  netKWHOver: data.netKWHOver === '' ? null : data.netKWHOver,
  inactiveReservThrs:
    data.inactiveReservThrs === '' ? null : data.inactiveReservThrs,
  mothBalledThrs: data.mothBalledThrs === '' ? null : data.mothBalledThrs,
  retiredThrs: data.retiredThrs === '' ? null : data.retiredThrs,
  omcMaintThrs: data.omcMaintThrs === '' ? null : data.omcMaintThrs,
  omcPlannedThrs: data.omcPlannedThrs === '' ? null : data.omcPlannedThrs,
})

const WEeMapEditRow = data => ({
  ...data,
  contractOverThrs: data.contractOverThrs === '' ? null : data.contractOverThrs,
  forcedOverThrs: data.forcedOverThrs === '' ? null : data.forcedOverThrs,
  maintOverThrs: data.maintOverThrs === '' ? null : data.maintOverThrs,
  // plannedThrs: data.plannedThrs === '' ? null : data.plannedThrs,
  plannedOverThrs: data.plannedOverThrs === '' ? null : data.plannedOverThrs,
  // ruOverThrs: data.ruOverThrs === '' ? null : data.ruOverThrs,
  omcForcedThrs: data.omcForcedThrs === '' ? null : data.omcForcedThrs,
  grossKWHOver: data.grossKWHOver === '' ? null : data.grossKWHOver,
  netKWHOver: data.netKWHOver === '' ? null : data.netKWHOver,
  inactiveReservThrs:
    data.inactiveReservThrs === '' ? null : data.inactiveReservThrs,
  mothBalledThrs: data.mothBalledThrs === '' ? null : data.mothBalledThrs,
  retiredThrs: data.retiredThrs === '' ? null : data.retiredThrs,
  omcMaintThrs: data.omcMaintThrs === '' ? null : data.omcMaintThrs,
  omcPlannedThrs: data.omcPlannedThrs === '' ? null : data.omcPlannedThrs,
})

const AepBlackColsSet = [
  'contractThrs',
  'contractOverThrs',
  'omcForcedThrs',
  'omcMaintThrs',
  'omcPlannedThrs',
  'rsThrs',
  // 'inactiveReservThrs',
]

const WEeBlackColsSet = [
  'contractThrs',
  'contractOverThrs',
  // 'omcForcedThrs',
  // 'omcMaintThrs',
  // 'omcPlannedThrs',
  'ruThrs',
  // 'inactiveReservThrs',
]

const AepReadOnlyCols = [
  'subGrpName',
  'subGrpId',
  'periodThrs',
  'activeThrs',
  'inactiveThrs',
  'contractThrs',
  'forcedThrs',
  'maintThrs',
  'ruThrs',
  'rsThrs',
  'grossKWH',
  'netKWH',
  'inactiveReservThrs',
  'mothBalledThrs',
  'retiredThrs',
]

const WEeReadOnlyCols = [
  'subGrpName',
  'subGrpId',
  'periodThrs',
  'activeThrs',
  'inactiveThrs',
  'contractThrs',
  'forcedThrs',
  'maintThrs',
  'ruThrs',
  // 'rsThrs',
  'grossKWH',
  'netKWH',
  'inactiveReservThrs',
  'mothBalledThrs',
  // 'retiredThrs',
  'omcForcedThrs',
  'omcMaintThrs',
  'omcPlannedThrs',
  'plannedThrs',
]

const AepHeaders = [
  strCol({
    ident: 'subGrpName',
    display: 'Subgroup Name',
    width: 150,
    isKey: true,
  }),
  numCol({
    ident: 'periodThrs',
    display: 'Period TH',
    isKey: true,
    displayFormat: '#,###',
  }),
  numCol({
    ident: 'activeThrs',
    display: 'Active TH',
    isKey: true,
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'inactiveThrs',
    display: 'Inactive TH',
    isKey: true,
    displayFormat: '#,###.00',
  }),

  numCol({
    ident: 'contractThrs',
    display: 'Contact TH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'contractOverThrs',
    display: 'Contact Override',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'forcedThrs',
    display: 'Forced TH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'forcedOverThrs',
    display: 'Forced Override',
    default: '',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'maintThrs',
    display: 'Maintenance TH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'maintOverThrs',
    display: 'Maint Override',
    default: '',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'plannedThrs',
    display: 'Planned TH',
    displayFormat: '#,###.00',
  }),

  numCol({
    ident: 'omcForcedThrs',
    display: 'OMC FTH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'omcMaintThrs',
    display: 'OMC MTH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'omcPlannedThrs',
    display: 'OMC PTH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'ruThrs',
    display: 'Resource Unavil TH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'ruOverThrs',
    display: 'Res. Unavail Override',
    default: '',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'rsThrs',
    display: 'Reserve Shutdown TH',
    displayFormat: '#,###.00',
  }),

  numCol({
    ident: 'grossKWH',
    display: 'Gross KWH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'grossKWHOver',
    display: 'Gross KWH Override',
    default: '',
    displayFormat: '#,###.00',
  }),
  numCol({ ident: 'netKWH', display: 'Net KWH', displayFormat: '#,###.00' }),
  numCol({
    ident: 'netKWHOver',
    display: 'Net KWH Override',
    default: '',
    displayFormat: '#,###.00',
  }),

  numCol({
    ident: 'inactiveReservThrs',
    display: 'Inactive Reserve TH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'mothBalledThrs',
    display: 'Mothball TH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'retiredThrs',
    display: 'Retired TH',
    displayFormat: '#,###.00',
  }),
]

const WEEheaders = [
  strCol({
    ident: 'subGrpName',
    display: 'Subgroup Name',
    width: 180,
    isKey: true,
  }),
  numCol({
    ident: 'periodThrs',
    display: 'Period TH',
    isKey: true,
    displayFormat: '#,###',
  }),
  numCol({
    ident: 'activeThrs',
    display: 'Active TH',
    isKey: true,
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'inactiveThrs',
    display: 'Inactive TH',
    isKey: true,
    displayFormat: '#,###.00',
  }),

  numCol({
    ident: 'contractThrs',
    display: 'Contact TH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'contractOverThrs',
    display: 'Contact Override',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'forcedThrs',
    display: 'Forced TH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'forcedOverThrs',
    display: 'Forced Override',
    default: '',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'maintThrs',
    display: 'Maintenance TH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'maintOverThrs',
    display: 'Maint Override',
    default: '',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'plannedThrs',
    display: 'Planned TH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'plannedOverThrs',
    display: 'Planned Override',
    default: '',
    displayFormat: '#,###.00',
  }),

  numCol({
    ident: 'omcForcedThrs',
    display: 'OMC FTH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'omcForcedOverThrs',
    display: 'OMC Forced Override',
    default: '',
    displayFormat: '#,###.00',
  }),

  numCol({
    ident: 'omcMaintThrs',
    display: 'OMC MTH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'omcMaintOverThrs',
    display: 'OMC Maint Override',
    default: '',
    displayFormat: '#,###.00',
  }),

  numCol({
    ident: 'omcPlannedThrs',
    display: 'OMC PTH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'omcPlannedOverThrs',
    display: 'OMC Planned Override',
    default: '',
    displayFormat: '#,###.00',
  }),

  numCol({
    ident: 'ruThrs',
    display: 'Resource Unavil TH',
    displayFormat: '#,###.00',
  }),
  /* numCol({
    ident: 'ruOverThrs',
    display: 'Res. Unavail Override',
    default: '',
    displayFormat: '#,###.00',
  }), */
  numCol({
    ident: 'rsThrs',
    display: 'Reserve Shutdown TH',
    displayFormat: '#,###.00',
  }),

  numCol({
    ident: 'grossKWH',
    display: 'Gross KWH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'grossKWHOver',
    display: 'Gross KWH Override',
    default: '',
    displayFormat: '#,###.00',
  }),
  numCol({ ident: 'netKWH', display: 'Net KWH', displayFormat: '#,###.00' }),
  numCol({
    ident: 'netKWHOver',
    display: 'Net KWH Override',
    default: '',
    displayFormat: '#,###.00',
  }),

  numCol({
    ident: 'inactiveReservThrs',
    display: 'Inactive Reserve TH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'mothBalledThrs',
    display: 'Mothball TH',
    displayFormat: '#,###.00',
  }),
  numCol({
    ident: 'retiredThrs',
    display: 'Retired TH',
    displayFormat: '#,###.00',
  }),
]
